import React from 'react';
import clsx from 'clsx';
import CurrencyTextField from 'core/components/CurrencyTextField';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';

type RangeValue = {
  min?: number | string | null;
  max?: number | string | null;
};

type Props = {
  value?: RangeValue;
  id: string;
  invalid?: boolean;
  onChange: (value: RangeValue) => void;
};

export default function Range({
  value,
  invalid = false,
  onChange,
  id,
}: Props) {
  const labelClasses = 'font-medium text-gray-500 absolute z-[2] -top-2 left-1.5 px-2 bg-white w-fit';

  return (
    <div className={clsx('populate-range-container flex flex-col', { 'has-error': invalid })}>
      <div className="range-input-container flex gap-3 items-center mt-1">
        <Wrapper
          id={`${id}-min`}
          labelClasses={labelClasses}
          label="Min"
          error={invalid}
          showErrorText={false}
        >

          <CurrencyTextField
            value={value?.min ?? ''}
            defaultValue=""
            nullIfEmpty
            allowNegative
            onChange={(inputValue) => {
              onChange({ ...value, min: inputValue });
            }}
          />
        </Wrapper>
        <Wrapper
          id={`${id}-max`}
          labelClasses={labelClasses}
          label="Max"
          error={invalid}
          showErrorText={false}
        >
          <CurrencyTextField
            value={value?.max ?? ''}
            defaultValue=""
            nullIfEmpty
            allowNegative
            onChange={(inputValue) => {
              onChange({ ...value, max: inputValue });
            }}
          />

        </Wrapper>
      </div>
      {invalid && (
        <div className="error-message text-xs">
          Max value must be greater than min
        </div>
      )}
    </div>
  );
}
